<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">资料列表</span>
      <div class="action-container">
        <a-button v-if="isAdmin" type="primary" icon="plus" @click="onCreateNew" class="page-title-btn">
          新建资料
        </a-button>
      </div>
    </div>
    <div class="content-container">
      <div class="search-container">
        <a-input placeholder="输入关键字搜索" v-model="keyword" class="medium-search-input">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-button
            @click="onSearch"
            class="search-btn"
        >搜索</a-button
        >
        <a-button @click="onReset">重置</a-button>
      </div>
      <div class="list-container">
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            @change="onTableChange"
        >
          <a-space slot="action" slot-scope="record">
            <a @click="onView(record)">查看</a>
            <a v-if="isAdmin" @click="onEdit(record)">编辑</a>
            <a v-if="isAdmin" @click="onDelete(record)" class="danger-text">删除</a>
          </a-space>
        </a-table>
      </div>
    </div>
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import {fetchUserList, deleteUser, resetPwd, isUserAdmin} from "@/services/UserService";
import { fetchRoleList } from "@/services/RoleService";
import {baseURL} from "@/services/HttpService";
import {listOptions} from "@/views/partner/PartnerApi";
import {deleteRefDoc, fetchDocList} from "@/services/RefDocApi";

const tblColumns = [
  {
    title: "文档名称",
    dataIndex: "docName",
    width: "40%"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    width: "40%"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "20%"
  }
];

export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      tblData: [],
      keyword: "",
      pagination: {
        size: "small",
        showQuickJumper: true
      },
      loading: false,
      isAdmin: false,
    };
  },
  computed: {
  },
  created() {
    isUserAdmin().then(resp => {
      if(resp.data.code === "SUCCESS") {
        this.isAdmin = resp.data.data;
      }
    });
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    onReset() {
      this.searchParams.realName = "";
      this.searchParams.partnerId = "";
      this.searchParams.roleId = "";
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        keyword: this.keyword,
        pageNum,
        pageSize
      };

      console.log('search params', params);

      fetchDocList(params).then(response => {
        this.loading = false;
        if (response.data.code === "FAILED") {
          console.log("服务端错误", response.data.errorMsg);
          this.$message.error("读取数据失败");
        } else {
          this.setTblData(response);
        }
      });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
        });
      }
      this.tblData = rltList;
      const pagination = { ...this.pagination };
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },
    onCreateNew() {
      this.$router.push({
        name: "EditRefDoc",
        params: {
          id: "0"
        }
      });
    },
    onView(record) {
      this.$router.push({
        name: "ViewRefDoc",
        params: {
          id: record.docId
        }
      });
    },
    onEdit(record) {
      this.$router.push({
        name: "EditRefDoc",
        params: {
          id: record.docId
        }
      });
    },
    onDelete(record) {
      let that = this;
      this.$confirm({
        title: "确定要删除吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          deleteRefDoc(record.docId).then(resp => {
            if (resp.data.code === "SUCCESS") {
              that.$message.success("删除成功");
              that.fetchList();
            } else {
              that.$message.error("删除失败:" + resp.data.errorMsg);
            }
          });
        }
      });
    },
    onResetPwd(record){
      let that = this;
      this.$confirm({
        title: "确定重置吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          resetPwd(record.userId).then(resp => {
            if (resp.data.code === "SUCCESS") {
              that.$message.success("操作成功");
            } else {
              that.$message.error("操作失败:" + resp.data.errorMsg);
            }
          });
        }
      });
    }

  }
};
</script>

<style scoped>

</style>
